#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TravelerAuthorizationCommonData {
  companyCurrencies(orderBy: [ISO_CODE_ASC]) {
    nodes {
      id
      name
      isoCode
    }
  }
  tripSections(orderBy: SORT_ORDER_ASC) {
    nodes {
      name
      layoutType
      sortOrder
      description
      id
      tripSectionItems(orderBy: SORT_ORDER_ASC) {
        nodes {
          id
          name
          layoutType
          sortOrder
        }
      }
    }
  }
  companyBusinessUnits(orderBy: [NAME_ASC]) {
    nodes {
      id
      name
      companyAddress {
        addressAlias
        addressLine1
        addressLine2
        cityName
        postalCode
      }
      _isCorporateWorkgroupRequired
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      _isTaSelectable
      userDepartment {
        _isUserAssigned
      }
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
}
